import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05e52f80")

_pushScopeId("data-v-05e52f80")
const _hoisted_1 = { class: "popup" }
const _hoisted_2 = {
  key: 0,
  class: "popup-wrap",
  ref: "PopUpRef"
}
const _hoisted_3 = { class: "wrap" }
const _hoisted_4 = { class: "button-with-chevron" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "icon-chevron" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Tooltip = _resolveComponent("Tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "popup-wrap" }, {
      default: _withId(() => [
        (_ctx.isActive)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "content", {}, undefined, true)
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Tooltip, { text: _ctx.tooltipBtn }, {
        button: _withId(() => [
          _createVNode(_component_Button, {
            class: "icon",
            mode: "outlined",
            size: "l",
            icon: { spriteUrl: '/image/videoconf-icons.svg', name: _ctx.name, color: '--sui-gray-700', width: _ctx.size, height: _ctx.size},
            "icon-only": "",
            disabled: _ctx.disabled,
            onClick: _ctx.toggleMedia
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }, 8, ["icon", "disabled", "onClick"])
        ]),
        _: 1
      }, 8, ["text"]),
      _createVNode(_component_Tooltip, {
        class: "button",
        text: _ctx.tooltipChevron
      }, {
        button: _withId(() => [
          _createVNode(_component_Button, {
            class: ["chevron", {'active': _ctx.isActive}],
            mode: "outlined",
            size: "l",
            disabled: _ctx.disabled,
            onClick: _ctx.toggleClass,
            ref: "PopUpButtonRef"
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["class", "disabled", "onClick"])
        ]),
        _: 1
      }, 8, ["text"])
    ])
  ]))
})